import {Component} from '@angular/core';
import {PageTypeEnum} from '@application/helper/navigation-helper/page-type.enum';
import {GridColorPreviewCellRendererParams} from '@presentation/pages/textile-data/color/overview/grid-color-preview/grid-color-preview-cell-renderer-params';
import {AssertionUtils, Color, LockIconConfig, NavigationHelperPrototypeService} from '@vdw/angular-component-library';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {IRowNode} from 'ag-grid-community';
import {Subject, takeUntil} from 'rxjs';

@Component({
  selector: 'app-grid-color-preview',
  templateUrl: './grid-color-preview.component.html',
  styleUrls: ['./grid-color-preview.component.scss']
})
export class GridColorPreviewComponent implements ICellRendererAngularComp {
  public showRGBValue = false;
  public color: Color;
  public node: IRowNode;
  public hasMultipleSelection = false;
  public isRuleCondition = false;
  public enableClickableName = false;
  public editPageUrl: string;
  public isNavigationHelper: boolean;
  public isLocked = false;
  public lockIconConfig: LockIconConfig;
  private params: GridColorPreviewCellRendererParams;
  private destroySubject = new Subject<void>();

  public constructor(private readonly navigationHelper: NavigationHelperPrototypeService) {}

  public agInit(params: GridColorPreviewCellRendererParams): void {
    this.params = params;
    this.node = params.node;
    this.color = params.color ?? this.getColorFromParams(params);
    this.showRGBValue = params.showRGBValue;
    this.hasMultipleSelection = params?.hasMultipleSelection;
    this.isRuleCondition = params?.isRuleCondition;
    this.enableClickableName = params?.enableClickableName;
    this.editPageUrl = params?.editPageUrl?.replace(':id', params.id ?? params.data.id.toString());
    this.isNavigationHelper = this.navigationHelper.contentSwitcherDialogActive();
    this.lockIconConfig = params.lockIconConfig;
    if (params.context?.canShowLockIcon) {
      this.isLocked = AssertionUtils.isNullOrUndefined(params.context?.lockCondition) ? params.data.used : params.context?.lockCondition(params.data);
    }
  }

  public destroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();
  }

  public refresh(params: any): boolean {
    return false;
  }

  public getReadableLabelForRGB(): string {
    if (!AssertionUtils.isNullOrUndefined(this.color.rgb)) {
      return Object.values(this.color.rgb).join(', ');
    }
    return '';
  }

  public canShowColorPreview(): boolean {
    return !AssertionUtils.isNullOrUndefined(this.color);
  }

  public navigateForward(event: Event): void {
    event.stopPropagation();
    const contentSwitcherEntry = this.params.contentSwitcherEntry;
    this.navigationHelper
      .navigateWithContentSwitcher({
        componentInfo: {
          component: contentSwitcherEntry.componentInfo.component,
          module: contentSwitcherEntry.componentInfo.module,
          componentInputs: {pageType: PageTypeEnum.EDIT, itemId: this.params.id ?? this.params.data.id, canShowHeader: true}
        }
      })
      .pipe(takeUntil(this.destroySubject))
      .subscribe((data: any) => this.params.rowActionsComplete?.next(data));
  }

  private getColorFromParams(params: GridColorPreviewCellRendererParams): Color {
    if (params.data instanceof Color) {
      return params.data;
    }
    return params.value;
  }
}
